<template>
  <div id="login">
    <section class="bd-index-fullscreen hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-6 has-text-centered">
              <!--<img src="@/assets/logo.png" alt="Image" width="20%">-->
              <img src="@/assets/logo.png" alt="Echo Ships" width="45%">
            </div>
          </div>
          <div class="columns is-centered">
            <div class="column is-4">
              <div>
                <form v-if="showLoginForm" @submit.prevent>
                  <h3 class="has-text-centered">
                    {{ $t('signin.welcome-back') }}
                  </h3>
                  <hr class="is-dark">
                  <b-field class="is-marginless">
                    <b-input
                      v-model.trim="loginForm.email"
                      maxlength="50"
                      type="text"
                      :placeholder="$t('signin.input-ph-email')"
                      id="email1">
                    </b-input>
                  </b-field>
                  <b-input type="password"
                    v-model.trim="loginForm.password"
                    maxlength="20"
                    :placeholder="$t('signin.input-ph-password')"
                    id="password1"
                    password-reveal>
                  </b-input>
                  <div>
                    <b-button @click="login" class="is-primary-grad is-rounded is-fullwidth">{{ $t('signin.button-signin') }}</b-button>
                  </div>
                  <br>  
                  <div>
                    <b-button @click="toggleForm" class="is-brand is-rounded is-fullwidth">{{ $t('signin.button-signup') }}</b-button>
                  </div>
                  <br>
                  <div class="has-text-centered">
                    <a @click="togglePasswordReset">{{ $t('signin.button-forgot-password') }}</a>
                  </div>
                  <hr class="is-dark">
                  <div class="level has-text-centered">
                    <p class="level-item">
                      {{ $t('signin.continue-with') }} &nbsp;
                      <b-button
                        @click="signInWithGoogle"
                        class="is-danger is-rounded"
                        size="is-small">
                        <span class="icon is-small">
                          <i class="ri-google-fill"></i>  
                        </span>
                        <span>Google Sign In</span>
                      </b-button>
                    </p>
                  </div>
                </form>
                <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
                  <h3 class="has-text-centered">{{ $t('signup.sign-up') }}</h3>
                  <hr class="is-dark">
                  <b-field class="is-marginless">
                    <b-input
                      v-model.trim="signupForm.name"
                      maxlength="30"
                      type="text"
                      :placeholder="$t('signup.input-ph-name')"
                      id="name"
                    ></b-input>
                  </b-field>
                  <b-field class="is-marginless">
                    <b-input
                      v-model.trim="signupForm.email"
                      maxlength="50"
                      :placeholder="$t('signup.input-ph-email')"
                      type="text"
                      id="email2"
                    ></b-input>
                  </b-field>
                  <b-field class="is-marginless">
                    <b-input
                      v-model.trim="signupForm.password"
                      maxlength="20"
                      type="password"
                      :placeholder="$t('signup.input-ph-password')"
                      id="password2"
                      password-reveal
                    ></b-input>
                  </b-field>
                  <b-button @click="signup" type="is-primary-grad is-rounded is-fullwidth">{{ $t('signup.button-continue') }}</b-button>
                  <div>
                    <br>
                    <b-button @click="toggleForm" class="is-brand is-rounded is-fullwidth">{{ $t('signup.button-already-member') }}</b-button>
                  </div>
                  <hr class="is-dark">
                  <div class="level has-text-centered">
                    <p class="level-item">
                      {{ $t('signup.continue-with') }} &nbsp;
                      <b-button
                        @click="signInWithGoogle"
                        class="is-danger is-rounded"
                        size="is-small"
                      >
                        <span class="icon is-small">
                          <i class="ri-google-fill"></i> 
                        </span>
                        <span>Google Sign In</span>
                      </b-button>
                    </p>
                  </div>
                </form>
                <form v-if="showForgotPassword" @submit.prevent class="password-reset">
                  <div v-if="!passwordResetSuccess">
                    <!--<h1>Reset Password</h1>-->
                    <div class="has-text-centered has-text-grey-light">{{ $t('signin.forgot-password') }}</div>
                    <hr class="is-dark">
                    <b-field>
                      <b-input
                        v-model.trim="passwordForm.email"
                        type="text"
                        :placeholder="$t('signin.input-ph-email')"
                        id="email3"
                      ></b-input>
                    </b-field>

                    <b-button
                      @click="resetPassword"
                      type="is-primary-grad is-rounded is-fullwidth"
                    >{{ $t('signin.button-submit') }}</b-button>

                    <div class="has-text-centered">
                      <br>
                      <a @click="togglePasswordReset">{{ $t('signin.button-return-signin') }}</a>
                    </div>
                  </div>
                  <div v-else>
                    <div class="has-text-centered">
                      <h1>{{ $t('signin.email-sent') }}</h1>
                      <p>{{ $t('signin.check-email') }}</p>
                      <br>
                      <button @click="togglePasswordReset" class="button is-primary">{{ $t('signin.button-return-signin') }}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hero-foot">
        <div class="container">
          <div class="tabs is-centered">
            <ul>
              <li>
                <a @click="isWelcomModalActive = true"
                  class="button is-brand is-rounded">
                  <span class="icon is-small has-text-primary">
                    <i class="ri-information-fill"></i>
                  </span>
                  <span>{{ $t('signup.button-what') }}</span></a>
                <br>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <b-modal :active.sync="isWelcomModalActive" :width="780" scroll="keep">
        <div class="card has-content-background-gradient">
          <div class="card-content">
            <div class="content">
              <h3>{{ $t('signup.product') }} <span class="has-text-brand">{{ $t('signup.launcher') }}</span></h3>
              <p>
                {{ $t('signup.intro-para-1') }}
              </p>
              <p>
                {{ $t('signup.intro-para-2') }}
              </p>
              <hr class="is-dark" />
              <b-button @click="isWelcomModalActive = false"
                class="is-primary-grad has-margin-bottom-10">
                <span>{{ $t('signup.button-get-started') }}</span>
                <span class="icon is-small">
                  <i class="ri-arrow-right-line"></i>  
                </span>
              </b-button>
              <br />
              <small>I{{ $t('signup.it-only') }}</small>
            </div>
          </div>
        </div>
      </b-modal>
      
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
      </b-loading>
    </section>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import firebase from "firebase";

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        type: "Individual",
        name: "",
        email: "",
        password: ""
      },
      passwordForm: {
        email: ""
      },
      showLoginForm: false,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      //errorMsg: ""
      isLoading: false,
      isFullPage: "",

      isWelcomModalActive: false,
    };
  },
  methods: {
    openLoading() {
      this.isLoading = true
      setTimeout(() => {
          this.isLoading = false
      }, 10 * 1000)
    },

    toggleForm() {
      this.errorMsg = "";
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true;
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showLoginForm = false;
        this.showForgotPassword = true;
      }
    },
    login() {
      this.isLoading = true;

      fb.auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");
          this.isLoading = false;
          this.$router.push("/posts");
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          //this.errorMsg = err.message;
          this.$toast.open({
            duration: 5000,
            message: err.message,
            position: "is-bottom",
            type: "is-danger"
          });
        });
    },
    signInWithGoogle() {

      const provider = new firebase.auth.GoogleAuthProvider();
      fb.auth
        .signInWithPopup(provider)
        .then(user => {
          console.log("user.user.displayName: " + user.user.displayName);
          this.$store.commit("setCurrentUser", user.user);

          fb.usersCollection
            .doc(user.user.uid)
            .get()
            .then(docSnapshot => {
              if (docSnapshot.exists) {
                console.log("user already exisits");
                //do nothing
                this.$router.push("/posts");
              } else {
                console.log(
                  "User dosn't exisits - now created for: " +
                    user.user.displayName
                );

                fb.usersCollection
                  .doc(user.user.uid)
                  .set({
                    name: user.user.displayName,
                    title: "",
                    taghandle: "",
                    position: "",
                    location: "",
                    type: "Individual",
                  })
                  .then(() => {
                    this.$store.dispatch("fetchUserProfile");
                    this.isLoading = false;
                    //this.$router.push("/dashboard");
                    this.$router.push("/NewUser");
                  })
                  .catch(err => {
                    console.log(err);
                    this.isLoading = false;
                    //this.errorMsg = err.message;
                    this.$toast.open({
                      duration: 5000,
                      message: err.message,
                      position: "is-bottom",
                      type: "is-danger"
                    });
                  });
              }
            })
            .catch(err => console.log("snapshot: " + err));
        })
        .catch(err => console.log("SIPOP: " + err));
    },
    signup() {
      this.isLoading = true;

      fb.auth
        .createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);

          // create user obj
          fb.usersCollection
            .doc(user.user.uid)
            .set({
              name: this.signupForm.name,
              title: "",
              taghandle: "",
              position: "",
              location: "",
              type: "Individual",

            })
            .then(() => {
              this.$store.dispatch("fetchUserProfile");
              this.isLoading = false;
              //this.$router.push("/dashboard");
              this.$router.push("/NewUser");
            })
            .catch(err => {
              console.log(err);
              this.isLoading = false;
              //this.errorMsg = err.message;
              this.$toast.open({
                duration: 5000,
                message: err.message,
                position: "is-bottom",
                type: "is-danger"
              });
            });
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          //this.errorMsg = err.message;
          this.$toast.open({
            duration: 5000,
            message: err.message,
            position: "is-bottom",
            type: "is-danger"
          });
        });
    },
    resetPassword() {
      this.isLoading = true;

      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.isLoading = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = "";
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          //this.errorMsg = err.message;
          this.$toast.open({
            duration: 5000,
            message: err.message,
            position: "is-bottom",
            type: "is-danger"
          });
        });
    }
  }
};
</script>